var _defs, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg15 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:gray;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 36.49,
    cy: 37.4,
    r: 52.89
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "15")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M108.92,75.7q-5.84-23.07-11.69-46.13C95,21,87.92,16.69,79.37,18.86l-61,15.44A13.88,13.88,0,0,0,8.12,51.47q11.8,46.8,23.7,93.56c2,8,9.42,12.32,17.48,10.28,20.13-5.1,40.22-10.38,60.42-15.21a14.61,14.61,0,0,0,10.94-18.29C116.54,106.5,112.81,91.07,108.92,75.7ZM40.28,88.82a5.28,5.28,0,0,1-5.83.84,5.06,5.06,0,0,1-2.94-5.46c.43-3.22,2.26-6,2.65-9.48a24.41,24.41,0,0,0,4.54,4.67,10.79,10.79,0,0,1,2.8,3.32A5.26,5.26,0,0,1,40.28,88.82Zm14.5-17.72a8.51,8.51,0,0,1-8.89,8.25,8.4,8.4,0,0,1-8-9.24A28.24,28.24,0,0,1,40,62.8a32,32,0,0,0,2.17-8.34c2.45,3.65,5.9,6,8.8,8.9C53.07,65.5,54.93,67.77,54.78,71.09ZM92.26,58q2.63,10.37,5.26,20.74a9.53,9.53,0,0,1,.36,3.77,4.45,4.45,0,0,1-3.62,4.11C88.81,88,83.39,89.39,78,90.76a4.61,4.61,0,0,1-5.82-2.65,13.54,13.54,0,0,1-1.06-2.85Q65.84,64.71,60.66,44.15a13.47,13.47,0,0,1-.41-2.82c-.1-3,1.17-4.61,4-5.34l15.55-3.94c3.29-.83,5.42.22,6.58,3.43.63,1.73,1,3.55,1.46,5.34Q90.09,49.42,92.26,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.49,6.55c3.86-1.49,7.72-3,11.58-4.47,3.7-1.42,6.76-.14,8.21,3.51,1.86,4.67,3.61,9.39,5.47,14.06.39,1,.28,1.42-.77,1.82q-16.33,6.24-32.61,12.6c-1.19.47-1.49.07-1.87-.93C7.72,28.37,5.83,23.64,4,18.88a5.67,5.67,0,0,1,3.35-7.64c4-1.61,8.07-3.13,12.11-4.69Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg15, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/15.2e47dd09.svg";
export { ForwardRef as ReactComponent };